import React, { useEffect, useState } from 'react';

import IconLike from '@components/Images/Rebranding/IconLike';
import useCommentLikersText from '@hooks/useCommentLikersText';
import MuiTooltip from '@mui/material/Tooltip';

export default function LikesCount({ count, commentId }: { commentId: number; count: number }) {
  const [enabled, setEnabled] = useState(false);
  const { likersFor } = useCommentLikersText(commentId, enabled);

  useEffect(() => {
    if (!enabled && count > 0) {
      setEnabled(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [count]);

  return (
    <MuiTooltip arrow placement="top" title={likersFor || ''} disableHoverListener={!enabled}>
      <div className="flex items-center gap-8">
        <IconLike className="w-16" />
        {count > 0 && <span>{count}</span>}
      </div>
    </MuiTooltip>
  );
}
